const programBeneficiaries = [
  {
    id: 'PB00',
    title: 'Institución pública',
    index: 1,
    color: '#76D4AF',
    colorFilterValues: {
      invert: '84',
      sepia: '11',
      saturate: '1228',
      hueRotate: '103', 
      brightness: '89',
      contrast: '92'
    }
  },
  {
    id: 'PB01',
    title: 'Institución privada',
    index: 2,
    color: '#76D4AF',
    branch: 'B',
    colorFilterValues: {
      invert: '84',
      sepia: '11',
      saturate: '1228',
      hueRotate: '103', 
      brightness: '89',
      contrast: '92'
    }
  }
]
export default programBeneficiaries
